import React, { useEffect } from 'react';
import { generatePath, useHistory } from 'react-router';
import { LoyaltyProgramHeaderPointsDropdown } from '@components-member/Pages/LoyaltyProgram/LoyaltyProgramHeaderPoints/LoyaltyProgramHeaderPointsDropdown';
import { LoyaltyProgramHeaderPointsItem } from '@components-member/Pages/LoyaltyProgram/LoyaltyProgramHeaderPoints/LoyaltyProgramHeaderPointsItem';
import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import styles from './loyaltyProgramHeaderPoints.styles.module.scss';

export const LoyaltyProgramHeaderPoints = observer(() => {
  const { fetchLoyaltyProgramInfo, LoyaltyProgramInfo } = useMobxStore().loyaltyProgramStore;

  const history = useHistory();

  useEffect(() => {
    void fetchLoyaltyProgramInfo();
  }, [fetchLoyaltyProgramInfo]);

  const handleItemClick = (id: number) => {
    history.replace(
      generatePath(EnumUserRoute.loyaltyProgramDetailsPage, {
        loyaltyProgramId: id,
      }),
      { redirectedBySingleRecord: true },
    );
  };

  const renderLoyaltyProgramHeader = () => {
    if (LoyaltyProgramInfo.length === 0) {
      return null;
    }

    if (LoyaltyProgramInfo.length > 1) {
      return <LoyaltyProgramHeaderPointsDropdown info={LoyaltyProgramInfo} />;
    }

    return (
      <LoyaltyProgramHeaderPointsItem
        wrapperClassName={styles.item}
        nameClassName={styles.name}
        pointsClassName={styles.points}
        loyaltyProgramName="Loyalty Points"
        loyaltyProgramPoints={LoyaltyProgramInfo[0].points}
        onClick={() => handleItemClick(LoyaltyProgramInfo[0].programId)}
      />
    );
  };

  return <div className={styles.loyaltyProgramHeaderPoints}>{renderLoyaltyProgramHeader()}</div>;
});
